export default __webpack_public_path__ + "static/media/who-never-do-2.0de614ab.png";